import React from "react";
import "../styles/Home.css";
import Particles from "react-particles-js";
import { Link } from "react-scroll";
import About from "./About";
import Projects from "./Projects";

function Home() {
  return (
    <>
      <div className="home">
        <div className="home__nav">
          <Link
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to={"section1"}
            className="home__navlink"
          >
            <span style={{ color: "#5ed6c0" }}>01.</span>About
          </Link>

          <Link
            activeClass="active"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            to={"section2"}
            className="home__navlink"
          >
            <span style={{ color: "#5ed6c0" }}>02.</span>Projects
          </Link>
          <a
            href="mailto:merveguzel.baykara@gmail.com"
            className="home__navlink"
          >
            <span style={{ color: "#5ed6c0" }}>03.</span>Contact
          </a>
        </div>

        {/* <Particles
          style={{ position: "absolute" }}
          height="95%"
          width="95%"
          params={{
            particles: {
              color: {
                value: "#0a192f",
              },
              line_linked: {
                color: {
                  value: "#ffffff",
                },
              },
              number: {
                value: 70,
              },
              size: {
                value: 3,
              },
              opacity: {
                value: 0.2,
              },
            },
          }}
        /> */}
        <div className="home__body">
          <p className="home__bodyHello">Hi, my name is</p>
          <p className="home__bodyName">Merve Baykara.</p>
          <p className="home__bodyDesc">I build things for the web.*kinda</p>
          <p className="home__bodyBio">
            I'm a software engineer student based in Istanbul,Turkey
            specializing in building websites, applications, and everything in
            between.
          </p>
          <a
            href="mailto:merveguzel.baykara@gmail.com"
            className="home__bodyMail"
          >
            Get In Touch
          </a>
        </div>
      </div>

      <div id="section1" className="about">
        <About />
        <div className="social-media">
          <a href={"https://github.com/mervegb"} className="github"></a>
          <a
            href={"https://www.linkedin.com/in/merve-baykara-480012177/"}
            className="linkedin"
          ></a>
        </div>
      </div>

      <div id="section2" className="projects">
        <Projects />
      </div>

      <script src="/__/firebase/7.18.0/firebase-app.js"></script>

      <script src="/__/firebase/init.js"></script>
    </>
  );
}

export default Home;
